/**
 * Variable mappings for night mode.
 *
 * @type {Object}
 */
const cssVariableMaps = {
	// gray-500
	'--wptb-plugin-theme-color-light': '#A0AEC0',
	// gray-300
	'--wptb-plugin-theme-text-color-main': '#E2E8F0',
	// gray-600
	'--wptb-plugin-gray-100': '#718096',
	// gray-400
	'--wptb-plugin-theme-sidebar-bg': '#CBD5E0',
	// gray-700
	'--wptb-plugin-logo-color': '#4A5568',
};

/**
 * @module cssVariableMaps
 */
export default cssVariableMaps;
